import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";
import { toast, NoticeRegion } from "../lib/notices";
import GoogleSignInButton from "../components/GoogleSignInButton";


export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  // Shared by password and Google sign-in, so both land the same way.
  const signedIn = () => { toast.success("Welcome back"); nav("/dashboard"); };

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, pw); signedIn(); }
    catch (err) { toast.error(errMsg(err, "Login failed")); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main id="main" tabIndex={-1} className="max-w-md mx-auto px-6 py-16">
        <div className="marquee-tag mb-4">// AUTH</div>
        <h1 className="font-display font-black type-title mb-8 tracking-tighter">SIGN IN.</h1>
        <NoticeRegion />
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="brutal-label" htmlFor="login-email">Email</label>
            <input id="login-email" data-testid="login-email" type="email" required className="brutal-input" value={email} onChange={(e)=>setEmail(e.target.value)} />
          </div>
          <div>
            <label className="brutal-label" htmlFor="login-password">Password</label>
            <input id="login-password" data-testid="login-password" type="password" required className="brutal-input" value={pw} onChange={(e)=>setPw(e.target.value)} />
          </div>
          <button data-testid="login-submit" disabled={loading} type="submit" className="brutal-btn w-full justify-center">{loading?"Signing in…":"Sign In"}</button>
          <div className="text-right text-xs mt-1">
            <Link to="/forgot" className="underline text-ink-muted hover:text-ink" data-testid="link-forgot">Forgot password?</Link>
          </div>
        </form>
        <GoogleSignInButton onSignedIn={signedIn} testId="login-google" />
        <p className="mt-8 text-sm text-center">
          No account? <Link to="/register" className="underline font-bold" data-testid="link-register">Create one</Link>
        </p>
      </main>
    </div>
  );
}
